/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Carregando"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var ptBR = Object.assign(TranslationProviderComponent, {
  translations
});

export { ptBR as p };
//# sourceMappingURL=pt-BR-DpgAuNS9.js.map
